<template>
    <fieldset :class="pData.fieldsetStyleClass">

        <legend v-if="pData.fieldsetLegendVisible">
            <i class="fa-light fa-stopwatch" aria-hidden="true"></i>
            <span class="bs3-margin-left3">
                {{ 'dictionary.project.timelog.mode.TIMER.plural' | i18nText(pDictionary) }}
            </span>
            <a class="btn btn-default ngWaiting right" style="margin-top: auto;" :href="listProjectUrl">
              <i class="fa-light fa-table"></i> {{ 'dictionary.project.timelog.mode.TIMER.list' | i18nText(pDictionary) }}
            </a>
        </legend>

        <div :class="pData.fieldsetBodyStyleClass">
            <div v-if="timerListEmptyVisible" class="bs3-padding">
                <span class="emptyOrNull">{{ 'dictionary.general.none' | i18nText(pDictionary) }}</span>
            </div>
            <ul v-if="timerListVisible" class="list-group bs3-margin-bottom-reset">
                <project-time-log-timer-list-item
                        v-for="timelog in pData.timeLogs"
                        :key="timelog.id"
                        :p-dictionary="pDictionary"
                        :p-urls="pUrls"
                        :p-src="pSrc"
                        :p-src-id="pSrcId"
                        :p-data="timelog">
                </project-time-log-timer-list-item>
            </ul>
        </div>

    </fieldset>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormatMixin from "@/mixins/format-mixin";
import ProjectTimeLogTimerListItem from "@/components/modules/production-module/project-timelog/fieldset-list-timer/ProjectTimeLogTimerListItem.vue";
import urlhelpers from "@/helpers/url-helpers";

export default {
   name: "ProjectTimeLogTimerListPopover",
   components: {ProjectTimeLogTimerListItem},
   mixins: [BaseMixin, FormatMixin],
   props: {
      pData: Object
   },
   computed: {
       listProjectUrl: function () {
         let url = this.pUrls['listMediaWorks'] + "?reset=true&resetProjects=true&dataListInput.projectIds=&dataListInput.mediaWorkStatusIds=0&dataListInput.mediaWorkIds=1";
         this.pData.timeLogs.forEach(function (timelog) {
           url = urlhelpers.appendIfDefined(url, 'dataListInput.mediaWorkIds', timelog.mediaWorkRef.id);
         });
         return url;
       },
       timerAvailable: function() {
           return this.pData.timeLogs.length !== 0;
       },
       timerListEmptyVisible: function() {
           return !this.timerAvailable && this.pData.timerListEmptyVisible;
       },
       timerListVisible: function() {
           return this.timerAvailable;
       }
   }
}
</script>

<style scoped>

</style>